// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + chunkId + ".js?v=" + {"184":"49e10805cb316545f050","810":"8e08bc69844a7c58c908","836":"e9748e77501e8acbab6b"}[chunkId] + "";
};